import type { Product } from '@/types'

export type ProductSizePick = 'first-in-stock' | 'random'

/** Variant names in product order (supports any label, incl. legacy 3ml/6ml/12ml). */
export function availableProductSizes(product: Product): string[] {
  return product.sizes?.map((v) => v.size).filter(Boolean) ?? []
}

/** First in-stock variant; if none in stock, first available; else empty string. */
export function firstInStockProductSize(product: Product): string {
  const available = availableProductSizes(product)
  if (available.length === 0) return ''
  const inStock = available.find(
    (name) =>
      (product.sizes?.find((v) => v.size === name)?.quantity ?? 0) > 0
  )
  return inStock ?? available[0]
}

/** Random available variant — used when all variants are out of stock too. */
export function randomProductSize(product: Product): string {
  const available = availableProductSizes(product)
  if (available.length === 0) return ''
  return available[Math.floor(Math.random() * available.length)]
}

/** Home grid: positions 1 & 4 prefer first in-stock variant; others random. */
export function homeSectionSizePick(index: number): ProductSizePick {
  return index === 0 || index === 3 ? 'first-in-stock' : 'random'
}

export function pickProductSize(
  product: Product,
  strategy: ProductSizePick = 'first-in-stock'
): string {
  return strategy === 'random'
    ? randomProductSize(product)
    : firstInStockProductSize(product)
}

/** @deprecated Use firstInStockProductSize */
export function defaultProductSize(product: Product): string {
  return firstInStockProductSize(product)
}
